export const DEMO_NOTES = {
  1: [
    {
      id: 1,
      queryID: 1,
      content: 'This looks like a great opportunity for our SEO experts.',
      whoAmI: 1,
      createdAt: '2025-10-20T11:30:00Z',
      updatedAt: '2025-10-20T11:30:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
    {
      id: 2,
      queryID: 1,
      content: 'Deadline is tight, need to respond by end of week.',
      whoAmI: 1,
      createdAt: '2025-10-20T14:15:00Z',
      updatedAt: '2025-10-20T14:15:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
  ],
  2: [
    {
      id: 3,
      queryID: 2,
      content: 'Brock Murray would be perfect for this - assigned to him.',
      whoAmI: 1,
      createdAt: '2025-10-21T09:20:00Z',
      updatedAt: '2025-10-21T09:20:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
    {
      id: 4,
      queryID: 2,
      content: 'Pitch sent! Waiting for response from journalist.',
      whoAmI: 1,
      createdAt: '2025-10-21T10:45:00Z',
      updatedAt: '2025-10-21T10:45:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
  ],
  3: [
    {
      id: 5,
      queryID: 3,
      content: 'Brock submitted his response yesterday.',
      whoAmI: 1,
      createdAt: '2025-10-22T16:50:00Z',
      updatedAt: '2025-10-22T16:50:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
  ],
  4: [
    {
      id: 6,
      queryID: 4,
      content: 'SUCCESS! Article published in Forbes. Great work Amanda!',
      whoAmI: 1,
      createdAt: '2025-10-26T10:35:00Z',
      updatedAt: '2025-10-26T10:35:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
    {
      id: 7,
      queryID: 4,
      content: 'Shared article link with the team. Celebrating this win!',
      whoAmI: 1,
      createdAt: '2025-10-26T11:00:00Z',
      updatedAt: '2025-10-26T11:00:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
  ],
  5: [
    {
      id: 8,
      queryID: 5,
      content: 'Query too technical, beyond our expertise. Discarding.',
      whoAmI: 1,
      createdAt: '2025-10-19T11:25:00Z',
      updatedAt: '2025-10-19T11:25:00Z',
      userInfo: {
        id: 1,
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@seoplus.ca',
      },
    },
  ],
};
